<ng-container
  *ngIf="!feedbackConfig.stages[feedbackConfig.activeStage]?.success"
>
  <h2 [class]="feedbackConfig.stages[0].title.classes || ''">
    {{ feedbackConfig.stages[0].title.text }}
  </h2>
  <section class="options-container">
    <section
      *ngFor="let option of feedbackConfig.stages[0].options"
      class="option"
      [class.checked]="feedbackConfig.selectedValue[0] === option.value"
    >
      <label class="option-container" [for]="option.value">
        <input
          class="radio-input"
          type="radio"
          name="why"
          [id]="option.value"
          [value]="option.value"
          [(ngModel)]="feedbackConfig.selectedValue[0]"
          (ngModelChange)="onInitialOptionChange()"
        />

        <span class="radio-button"></span>

        <span class="radio-text">
          <dgx-components-icon
            *ngIf="option.icon"
            [name]="option.icon"
            size="lg"
          >
          </dgx-components-icon>
          {{ option.label }}
        </span>
      </label>
    </section>
  </section>
</ng-container>

<h2
  [class]="
    feedbackConfig.stages[feedbackConfig.activeStage].title.classes || ''
  "
  [class.freeTextInput]="
    feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput
  "
  *ngIf="feedbackConfig.activeStage !== 0"
>
  <dgx-components-icon
    *ngIf="feedbackConfig.stages[feedbackConfig.activeStage].title.icon"
    [name]="feedbackConfig.stages[feedbackConfig.activeStage].title.icon"
  >
  </dgx-components-icon>
  {{ feedbackConfig.stages[feedbackConfig.activeStage].title.text }}
</h2>

<p
  *ngIf="
    feedbackConfig.stages[feedbackConfig.activeStage]?.success && !vm.isHappy
  "
>
  We’ll check the details you’ve shared and put things right as quickly as
  possible.
</p>

<div *ngIf="feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput">
  <div>
    <p>
      If you didn’t find what you needed, tell us a bit more in the form below
      and we’ll do our best to get things sorted quickly.
    </p>
  </div>

  <div class="paragraph">
    <p class="item-list-title">Please let us know:</p>
    <ul class="item-list">
      <li>What you’re trying to do</li>
      <li>What’s happened so far</li>
      <li>Anything else that would help us fix things for you</li>
    </ul>
    <p class="paragraph">
      We’ll use the same contact details as your repair booking.
    </p>
  </div>
</div>

<ng-container
  *ngIf="feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput"
>
  <section class="free-text-holder">
    <textarea
      #textArea
      placeholder="Enter your message here..."
      [ngModel]="feedbackConfig.selectedValue[feedbackConfig.activeStage]"
      (ngModelChange)="freeTextInput($event, textArea)"
      [rows]="5"
      [class.text-box-error]="showOptionError"
    >
    </textarea>

    <span class="character-count">
      <span
        [class.invalid]="
          feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length >
          (feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount ||
            5000)
        "
      >
        {{
          feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length || 0
        }}</span
      >/{{
        feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount || 5000
      }}
    </span>
  </section>

  <section
    *ngIf="showOptionError"
    class="selection-error"
    style="display: flex; gap: 8px"
  >
    <dgx-components-icon name="circle-exclamation"> </dgx-components-icon>
    <ng-container
      *ngIf="
        feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length >
          (feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount ||
            5000);
        else MissingDescription
      "
    >
      You have exceeded the character limit
    </ng-container>

    <ng-template #MissingDescription> Enter your message </ng-template>
  </section>
</ng-container>

<dgx-components-button
  class="submit-button"
  *ngIf="feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput"
  [variant]="
    feedbackConfig.stages[feedbackConfig.activeStage].button?.variant ||
    'primary'
  "
  [fill]="true"
  (clicked)="submitFeedback()"
>
  {{
    feedbackConfig.stages[feedbackConfig.activeStage].button?.text || 'Submit'
  }}
</dgx-components-button>
